import { render, staticRenderFns } from "./SeletorDeTabelasDePrecoComParcelas.vue?vue&type=template&id=739998b5&scoped=true&"
import script from "./SeletorDeTabelasDePrecoComParcelas.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeTabelasDePrecoComParcelas.vue?vue&type=script&lang=ts&"
import style0 from "./SeletorDeTabelasDePrecoComParcelas.vue?vue&type=style&index=0&id=739998b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739998b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VDivider,VIcon})
